import { useEffect, useState } from 'react';
import { startOfDay } from '@/lib/week.ts';

const CHECK_MS = 60_000;

/**
 * Midnight of the current day, moved on when the date turns over: an agenda
 * left open for days still knows which day, and which week, is today.
 */
export function useToday(): Date {
  const [today, setToday] = useState(() => startOfDay(new Date()));

  useEffect(() => {
    const timer = window.setInterval(() => setToday(laterDay), CHECK_MS);

    return () => window.clearInterval(timer);
  }, []);

  return today;
}

/* The same Date while the day holds, so nothing downstream re-renders. */
function laterDay(current: Date): Date {
  const today = startOfDay(new Date());
  return today.getTime() === current.getTime() ? current : today;
}
